module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty14.aa17536f.jpg";